// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"8052a4ed","453":"690123b1"}[chunkId] + ".chunk.js";
};